import { useGetCardTransactionsQuery } from "@/modules/card/services";
import { HistoryDetail } from "@/shared/components";
import { getFormattedHistoryList } from "@/shared/helpers";
import { useMemo } from "react";

interface Props {
  cardId: string;
}

export const CardDetailOfflineHistory = ({ cardId }: Props) => {
  const { data: cardHistory, isFetching } = useGetCardTransactionsQuery(
    { cardId },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const historyList = useMemo(() => {
    return getFormattedHistoryList({
      list: cardHistory ?? [],
      beneficiaryKey: "receiver",
    });
  }, [cardHistory]);

  return (
    <HistoryDetail
      isFetching={isFetching}
      historyList={historyList}
    />
  );
};
